import React, { useEffect, useRef } from 'react';
import Navbar from "../Components/Navbar";
import img from "../Assets/abouthome.png";
import icon from "../Assets/Background+Border+OverlayBlur.png";
import OurUniqueness from "../Assets/new.jpeg";
import mission from "../Assets/AdobeStock_733305920_Preview.jpeg";
import Footer from "../Components/Footer";
import CountUp from "../Components/CountUp";
import Slider from "../Components/Slider";
import { Link } from 'react-router-dom';
function Home() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    const cardWidth = container?.children[0]?.offsetWidth || 300;
    let scrollPos = 0;

    const interval = setInterval(() => {
      if (!container) return;

      scrollPos += cardWidth;

      if (scrollPos >= container.scrollWidth - container.clientWidth) {
        scrollPos = 0; // reset to start
      }

      container.scrollTo({
        left: scrollPos,
        behavior: 'smooth',
      });
    }, 2000);

    return () => clearInterval(interval); // cleanup
  }, []);
  return (
    <>
      <Navbar />
      <Slider/>

      <div className="home-about">
        <div className="home-about-left">
          <h4>Who We Are ?</h4>
          <h3>Delivering Innovative Solutions Globality</h3>
          <p>
          Semicave semiconductor is emerging as a leader in providing engineering solutions worldwide.
<br/>
<br/>
We offer end-to-end Semiconductor, Embedded, Automotive and System Design to design and build next-generation leadership products under one roof. And allowing clients to achieve both quick wins and long-term results.
<br/>
<br/>
Our goal is to be an extended arm of engineering product and IT companies and ensure good quality productization cost-effectively.

          </p>
        </div>
        <div className="home-about-right">
          <img src={img} />
        </div>
      </div>
      <div className="services">
        <div className="services-heading">
          <p>OUR SERVICES</p>
          <h3>
            Innovative Services
            <br /> Exceptional Results
          </h3>
        </div>
        <br />
        <br />
        <div className="services-cards">
                 <Link className='non' to='/siliconengineering'>

          <div className="services-card">
            <img src={icon} />
            <h3>Silicon/semiconductor Engineering</h3>
            <p>Chips from spec to silicon/VLSI, Seamless Collaboration.</p>
               <Link to='/siliconengineering'>

          <button>Read More</button>
          </Link>

          </div>
        </Link>
             <Link  className='non' to='/systemdesign'>

          <div className="services-card">
            <img src={icon} />
            <h3>System Design</h3>
            <p>Full Stack Embedded Solution Support Across Platforms.</p>
             <Link to='/systemdesign'>
           
                     <button>Read More</button>
                     </Link>
          </div>
        </Link>
                <Link  className='non' to='/embeddedsolutions'>

          <div className="services-card">
            <img src={icon} />
            <h3>Embedded Solutions

</h3>
            <p>Powering Tomorrow’s Semiconductor Innovations with AI.</p>
                <Link to='/embeddedsolutions'>
           
                     <button>Read More</button>
                     </Link>
          </div>
        </Link>
               <Link  className='non' to='/artificialintelligence'>

          <div className="services-card">
            <img src={icon} />
            <h3>Artificial Intelligence</h3>
            <p>From Vision To Certification, Innovating Success.</p>
               <Link to='/artificialintelligence'>
            
                      <button>Read More</button>
                      </Link>
          </div>
        </Link>
    <Link className='non' to='/automotivesolutions'>

          <div className="services-card">
            <img src={icon} />
            <h3>Automotive Solutions</h3>
            <p>Driving Tomorrow Real time Innovation for Accuracy & Quality.</p>
    <Link to='/automotivesolutions'>

          <button>Read More</button>
          </Link>
          </div>
        </Link>

        </div>
      </div>
      <br />
      <br />
      <div className="OurUniqueness">
        <div className="services-heading">
          <p>Our Uniqueness</p>
          <h3>Defining Distinct Excellence</h3>
        </div>
        <br />
        <br />
        <div className="OurUniqueness-div">
          <div className="OurUniqueness-div-left">
            <h3>Empowering Innovation</h3>
            <p>
              We uphold the highest standards of honesty and transparency in all
              our interactions.
            </p>
            <h3>Guiding Customers from concept to completion</h3>
            <p>
             We are dedicated to fostering a culture of creativity and forward- thinking.
            </p>
            <h3>Prioritizing Transparency</h3>
            <p>
             We strive for excellence in every project and service we deliver.
            </p>
            <h3>Comprehensive Infrastructure Management</h3>
            <p>
              We uphold the highest standards of honesty and transparency in
all our interactions.
            </p>
          </div>
          <div className="OurUniqueness-div-right">
            <img src={OurUniqueness} />
          </div>
        </div>
      </div>
      <div className="Industries">
        <div className="Industries-heading">
          <p>Industries</p>
          <h3>Industries We Cator To</h3>
        </div>
        <br />
        <br />
        <div className="Industries-cards" ref={scrollRef}>
          <div>
            <div className="Industries-card Industries-card2">
              <div className="industries-text">
                <h3>IoT,Networking & Industrial</h3>
              </div>
            </div>
          </div>

          <div>
                      <div className="Industries-card Industries-card3">

              <div className="industries-text">
                <h3>Semiconductor</h3>
              </div>
            </div>
          </div>
          <div>
            <div className="Industries-card Industries-card4">
              <div className="industries-text">
                <h3>Agriculture</h3>
              </div>
            </div>
          </div>
          <div>
            <div className="Industries-card Industries-card5">
              <div className="industries-text">
                <h3>Automotive</h3>
              </div>
            </div>
          </div>
          <div>
            <div className="Industries-card Industries-card6">
              <div className="industries-text">
                <h3>Medical Devices</h3>
              </div>
            </div>
          </div>


            <div>
            <div className="Industries-card Industries-card7">
              <div className="industries-text">
                <h3>AI & Robotics</h3>
              </div>
            </div>
          </div>


            <div>
            <div className="Industries-card Industries-card8">
              <div className="industries-text">
                <h3>Security</h3>
              </div>
            </div>
          </div>



            <div>
            <div className="Industries-card Industries-card9">
              <div className="industries-text">
                <h3>Consumer Electronics</h3>
              </div>
            </div>
          </div>


            <div>
            <div className="Industries-card Industries-card10">
              <div className="industries-text">
                <h3>Aerospace</h3>
              </div>
            </div>
          </div>
             <div>
            <div className="Industries-card Industries-card11">
              <div className="industries-text">
                <h3>Industrial Automation</h3>
              </div>
            </div>
          </div>
             <div>
            <div className="Industries-card Industries-card12">
              <div className="industries-text">
                <h3>Transport & Logistics</h3>
              </div>
            </div>
          </div>
             <div>
            <div className="Industries-card Industries-card13">
              <div className="industries-text">
                <h3>Home Automation</h3>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="our-mission">
        <div className="our-mission-left">
          <h3><span>Our mission is to empower Engineering</span></h3>
          <h3>through innovative solutions and exceptional service.</h3>
        </div>
        <div className="our-mission-right">
          <img src={mission} />
        </div>
      </div>
 <div className="persent">
  <div className="persent-div">
    <CountUp end={95} suffix="%" fontClass="text-4xl font-bold text-green-600" />
    <p>Customer Satisfaction Rate</p>
  </div>
  <div className="persent-div">
    <CountUp end={50} suffix="%" fontClass="text-4xl font-bold text-blue-600" />
    <p>Average Increase</p>
  </div>
  <div className="persent-div">
    <CountUp end={30} suffix="+" fontClass="text-4xl font-bold text-orange-600" />
    <p>Industries Served</p>
  </div>
</div>

      <div className="ESMI-text">
        <h3>
          "Semicave Semiconductor our business operations with their strategic
          planning and technology integration services.<span>

           Our efficiency has
          increased significantly, and we've seen remarkable growth in a short
          period."
          </span>
        </h3>
      </div>
      <Footer />
    </>
  );
}

export default Home;
